'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCropRotate = function MdCropRotate(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.4 26.6h20v3.4h-3.4v3.4h-3.4v-3.4h-13.2c-1.9 0-3.4-1.6-3.4-3.4v-13.2h-3.4v-3.4h3.4v-3.4h3.4v20z m13.2-3.2v-10h-10v-3.4h10c1.8 0 3.4 1.5 3.4 3.4v10h-3.4z m-6.5-23.4c10.4 0 19 8.1 19.9 18.4h-2.5c-0.6-6.3-4.5-11.6-9.9-14.2l-2.3 2.2-6.3-6.3c0.4 0 0.7-0.1 1.1-0.1z m-7.7 35.8l2.3-2.2 6.3 6.3c-0.4 0-0.7 0.1-1.1 0.1-10.4 0-19-8.1-19.9-18.4h2.5c0.6 6.3 4.5 11.6 9.9 14.2z' })
        )
    );
};

exports.default = MdCropRotate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/crop-rotate.js
// module id = 629
// module chunks = 0